/* Built In Imports */
/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import LazyLoadImageComponent from '@moms/Ui/LazyLoadImageComponent';
/* Internal Imports */
/* Components */
import config from '@config';
import TopBannerSt from '@moms/styleData/TopbannerSt';
/* Services */

/**
 * Renders the Quote Component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - data
 * @returns {ReactElement} Quote component
 */
const Quote = ({ sectionContent, region, lang }) => {
  return (
    <Box
      pos={'relative'}
      py={{ base: '6rem', md: '10rem' }}
      px="2rem"
      w="100%"
      _after={{
        content: "''",
        pos: 'absolute',
        height: '0.6px',
        left: '0',
        right: '0',
        width: '100%',
        bottom: '0',
        zIndex: '1',
        background:
          'radial-gradient(80.14% 21.43% at 50% 50%, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.00) 100%), #010102',
        backdropFilter: 'blur(calc(var(--sds-size-blur-100) / 2))',
        borderTop: '1px solid rgba(255, 255, 255, 0.20)',
      }}
    >
      <Flex
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        w="100%"
        maxW={450}
        mx="auto"
      >
        <Box
          pos="relative"
          m={'auto'}
          color="#fff"
          textAlign="center"
          {...TopBannerSt[lang].quoteSt}
        >
          {`"${sectionContent.quote}"`}
        </Box>
        <Box>
          <LazyLoadImageComponent
            mt="1rem"
            src={`${config.imgPath}/d/46272/1731050948-sadhguru-signature.png`}
            alt="sadhguru signature"
            height="56px"
          />
        </Box>
      </Flex>
    </Box>
  );
};

export default Quote;
